<template>
    <v-card class="card--flex-toolbar">
        <v-app-bar flat prominent :height="40">
            <v-toolbar-title class="subtitle-1 grey-darken-3--text">{{this.module.nameUk}}</v-toolbar-title>
        </v-app-bar>
        <v-divider></v-divider>

        <v-tabs
                v-model="activeSub"
                background-color="blue lighten-3"
                dark
                centered
                fixed-tabs
                class="tabs-wrapper mark-type-tab-wrapper"
                icons-and-text
                :height="60"
        >
            <v-tabs-slider class="tab-slider-top" color="amber darken-4"></v-tabs-slider>
            <v-tab
                    ripple
                    key="all_marks"
                    active-class="mark-type-active-tab"
            >
                <span class="hidden-sm-and-down">Практичні заняття</span>
                <v-icon>line_style</v-icon>
            </v-tab>
            <v-tab
                    v-if="module.hasLectures"
                    ripple
                    key="lectures"
                    active-class="mark-type-active-tab"
            >
                <span class="hidden-sm-and-down">Лекційні заняття</span>
                <v-icon>library_books</v-icon>
            </v-tab>
            <v-tab
                    v-if="module.hasIndividualWork"
                    ripple
                    key="individual_work"
                    active-class="mark-type-active-tab"
            >
                <span class="hidden-sm-and-down">Самостійна робота</span>
                <v-icon>person_add</v-icon>
            </v-tab>
            <v-tab
                    ripple
                    key="module"
                    active-class="mark-type-active-tab"
            >
                <span class="hidden-sm-and-down">{{mapFinalControlType(this.module.finalControlType)}}</span>
                <v-icon>event_note</v-icon>
            </v-tab>
            
            <v-tabs-items v-model="activeSub" touchless>
                <v-tab-item key="all_marks">
                    <marks-list :activeModule="activeModule"/>
                </v-tab-item>
                <v-tab-item key="lectures" v-if="this.module.hasLectures">
                    <lecture-list :activeModule="activeModule" />
                </v-tab-item>
                <v-tab-item key="individual_work" v-if="this.module.hasIndividualWork">
                    <individual-work-list :activeModule="activeModule"/>
                </v-tab-item>
                <v-tab-item key="module">
                    <module-list :activeModule="activeModule"/>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>
<script>
    import finalControlTypes from "../../../constants/admin/finalControlTypes";
    import MarksList from "./MarksList";
    import ModuleList from "./ModuleList";
    import LectureList from "./lectures/LectureList";
    import IndividualWorkList from "./IndividualWorkList";

    export default {
        components: {
            MarksList,
            ModuleList,
            LectureList,
            IndividualWorkList
        },
        data: () => ({
            modules: [],
            activeSub: null,
        }),
        props: {
            module: {
                type: Object
            },
            activeModule: {
                type: Object,
            }
        },
        methods: {
            mapFinalControlType(finalControlType) {
                return finalControlTypes.find(f => f.typeEnum === finalControlType).nameConst;
            }
        },
    }
</script>
<style>
    .mark-type-tab-wrapper .v-tab {
        font-size: 0.8em;
    }
</style>